// frontend/src/components/admin/CreateUser.jsx
import React, { useState } from "react";
import { ArrowLeft, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../utils/api";
import { toast } from "../../utils/toast";
import "./admin-shell.css";

function CreateUser() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("client");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await apiPost("/api/users/create", {
        name,
        email,
        password,
        role,
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("User created successfully!");
        setName("");
        setEmail("");
        setPassword("");
        setRole("client");
      } else {
        toast.error(data.message || "Failed to create user");
      }
    } catch (err) {
      toast.error("Network error during user creation.");
    }
  };

  return (
    <div className="admin-workspace">
      <section className="admin-shell-header">
        <div className="admin-shell-copy">
          <span className="admin-shell-eyebrow">Identity Operations</span>
          <h1 className="admin-shell-title">Create user account</h1>
          <p className="admin-shell-subtitle">Provision new user identities with standardized roles and credentials.</p>
        </div>
      </section>

      <section className="admin-panel" style={{ maxWidth: 720 }}>
        <div className="admin-page-header">
          <div>
            <h2 className="admin-page-title">New user form</h2>
            <p className="admin-page-subtitle">Fill required account fields and assign the operational role.</p>
          </div>
          <button type="button" className="admin-btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeft size={14} />
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit} className="admin-stack-md">
          <div className="admin-form-grid">
            <div className="admin-form-field">
              <label>Name</label>
              <input type="text" required value={name} onChange={(e) => setName(e.target.value)} className="admin-input" />
            </div>

            <div className="admin-form-field">
              <label>Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input" />
            </div>

            <div className="admin-form-field">
              <label>Password</label>
              <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="admin-input" />
              <small style={{ color: "#8ca8b3" }}>
                At least 8 characters with a mix of uppercase, lowercase, numbers, and symbols.
              </small>
            </div>

            <div className="admin-form-field">
              <label>Role</label>
              <select value={role} onChange={(e) => setRole(e.target.value)} className="admin-input">
                <option value="client">Client</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          </div>

          <div className="admin-actions">
            <button type="submit" className="admin-btn">
              <UserPlus size={14} />
              Create User
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}

export default CreateUser;
